<script setup lang="ts">
import { CloseIcon } from '#shared/components/icons';

const props = withDefaults(
  defineProps<{
    modelValue?: boolean;
    title?: string;
    closable?: boolean;
  }>(),
  {
    title: '',
    closable: false,
  }
);
const emit = defineEmits<{
  (e: 'update:modelValue', modelValue: boolean): void;
}>();

function close() {
  emit('update:modelValue', false);
}
</script>

<template>
  <div v-if="props.modelValue" class="window">
    <div class="window__title">
      {{ props.title }}
      <AppButton
        v-if="props.closable"
        variant="link"
        :icon-end="CloseIcon"
        @click="close"
      />
    </div>
    <div class="window__content">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped lang="scss">
.window {
  background: var(--app-color-white);
  border-radius: 12px;
  padding: 16px;
  position: relative;
  overflow: hidden;
  border: 1px solid var(--app-color-white-quaternary);

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 4px;
    height: 100%;
    background-color: var(--app-color-tertiary);
  }

  &__title {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    font-style: normal;
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    margin-bottom: 4px;
  }

  &__content {
    font-size: 15px;
    line-height: 22px;
  }
}
</style>
